import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/assistenzaNetwork',
        name: 'assistenzaNetwork',
        meta: { sideMenuLabel: "Assistenza network" },
        component: () => import("./views/assistenzaNetwork.vue")
    },
    {
        path: '/chat/:identifier',
        name: 'chatPage',
        component: () => import("@/components/chat/chatPage.vue")
    },
];

export default routes;